module.exports = __webpack_public_path__ + "img/789.da1b1b15.jpg";